import * as React from 'react';

// Placeholder wordmark tile (Inner Range Inception brand style: dark tile,
// lowercase wordmark, cyan accent blocks). Swap for licensed brand art when
// marketing supplies it.
const SvgComponent = (props) => (
	<svg width='98' height='99' viewBox='0 0 98 99' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<rect width='98' height='99' rx='9' fill='#1A1A1A' />
		<rect x='63' y='38' width='7' height='7' fill='#00B4D8' />
		<rect x='72' y='38' width='7' height='7' fill='#00B4D8' />
		<rect x='63' y='47' width='7' height='7' fill='#00B4D8' />
		<rect x='72' y='47' width='7' height='7' fill='#00B4D8' />
		<rect x='63' y='56' width='7' height='7' fill='#00B4D8' />
		<rect x='72' y='56' width='7' height='7' fill='#00B4D8' />
		<text x='19' y='58' fill='#FFFFFF' fontFamily='Arial, Helvetica, sans-serif' fontSize='17' fontWeight='bold'>
			in
		</text>
		<text x='19' y='76' fill='#9CA3AF' fontFamily='Arial, Helvetica, sans-serif' fontSize='10'>
			inception
		</text>
	</svg>
);

export default SvgComponent;
